import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import ContractsTableWithFilters from './ContractsTable';

// ==============================|| CONTRACT LIST PAGE ||============================== //

const ContractsListPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'contracts.contracts'}
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.CONTRACTS']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/contract/new`)}
                            labelId="contracts.add-new-contract"
                            newLabelId="new-entity.contract"
                        />
                    }
                />
                <ContractsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default ContractsListPage;
